import styled from 'styled-components';

export const Title = styled.h2`
  margin: 0;
`;

export const Form = styled.form`
  height: calc(100% - 130px);
`;

export const Body = styled.div`
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
`;

export const BodyContainer = styled.div`
  padding: 0 20px;
`;

export const Label = styled.label`
  display: flex;
  margin-bottom: 20px;
  font-size: 17px;
  font-weight: bold;
`;

export const ClearButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 45px;
  width: 150px;
  margin: 20px 20px 0 auto;
  color: white;
  font-weight: 400;
  font-size: 20px;
  background: #11465d;
  border-radius: 10px;
`;

export const DateContainer = styled.div`
  margin-top: 20px;
`;

export const Row = styled.div`
  display: flex;
  column-gap: 10px;
`;

export const Field = styled.div`
  margin-top: 20px;
`;
